import { request, requestPage } from '@/lib/apiClient';
import { endpoints } from '@/features/endpoints';
import type { SupportTicketDetail, SupportTicketSummary, TicketStatus } from '@/types/domain';
import type { Page } from '@/types/api';

export function fetchTickets(
  params: { status?: string; limit?: number; cursor?: string },
  signal?: AbortSignal,
): Promise<Page<SupportTicketSummary>> {
  return requestPage<SupportTicketSummary>(endpoints.tickets.list, {
    query: { status: params.status, limit: params.limit ?? 25, cursor: params.cursor },
    ...(signal ? { signal } : {}),
  });
}

export function fetchTicket(id: string, signal?: AbortSignal): Promise<SupportTicketDetail> {
  return request<SupportTicketDetail>(endpoints.tickets.detail(id), signal ? { signal } : {});
}

export function updateTicket(
  id: string,
  patch: { status?: TicketStatus; assigneeUid?: string | null },
): Promise<SupportTicketDetail> {
  return request<SupportTicketDetail>(endpoints.tickets.detail(id), {
    method: 'PATCH',
    body: patch,
  });
}

export function replyToTicket(id: string, body: string): Promise<SupportTicketDetail> {
  return request<SupportTicketDetail>(endpoints.tickets.reply(id), {
    method: 'POST',
    body: { body },
  });
}
